"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Besteller = _interopRequireDefault(require("./Besteller"));
var _BooleanJN = _interopRequireDefault(require("./BooleanJN"));
var _HeaderRequest = _interopRequireDefault(require("./HeaderRequest"));
var _RequestHeader = _interopRequireDefault(require("./RequestHeader"));
var _WarenkorbPos = _interopRequireDefault(require("./WarenkorbPos"));
var _Warenkorbdetails = _interopRequireDefault(require("./Warenkorbdetails"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Orders model module.
 * @module model/Orders
 * @version 1.0.44
 */
var Orders = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Orders</code>.
   * Bestellung eines Kunden
   * @alias module:model/Orders
   * @implements module:model/HeaderRequest
   * @param header {module:model/RequestHeader} 
   * @param bestellerInformationen {module:model/Besteller} 
   * @param rechtlichesHinweis1 {Number} Rechtlicher Hinweis (1= bestätigt, 0= nicht bestätigt)
   * @param rechtlichesHinweis2 {Number} Rechtlicher Hinweis (1= bestätigt, 0= nicht bestätigt)
   * @param rechtlichesHinweis3 {Number} Rechtlicher Hinweis (1= bestätigt, 0= nicht bestätigt)
   * @param rechtlichesHinweis4 {Number} Rechtlicher Hinweis (1= bestätigt, 0= nicht bestätigt)
   * @param rechtlichesHinweis5 {Number} Rechtlicher Hinweis
   * @param userId {String} ID des Mitarbeiters
   * @param edelmetallWarenkorb {module:model/Warenkorbdetails} 
   * @param edelmetallWarenkorbPos {Array.<module:model/WarenkorbPos>} alle Einzelpositionen des Warenkorbs
   * @param innenprovision {Number} Kosten der Provision
   * @param emProvZusKz {module:model/Orders.EmProvZusKzEnum} Provisionszusatz \"J\"a oder \"N\"ein
   * @param kundenId {Number} Kunden ID
   * @param bemerkungen {Array.<String>} Zusätzliche Bemerkungen je einzelner Warekorb Position
   */
  function Orders(header, bestellerInformationen, rechtlichesHinweis1, rechtlichesHinweis2, rechtlichesHinweis3, rechtlichesHinweis4, rechtlichesHinweis5, userId, edelmetallWarenkorb, edelmetallWarenkorbPos, innenprovision, emProvZusKz, kundenId, bemerkungen) {
    _classCallCheck(this, Orders);
    _HeaderRequest.default.initialize(this, header);
    Orders.initialize(this, header, bestellerInformationen, rechtlichesHinweis1, rechtlichesHinweis2, rechtlichesHinweis3, rechtlichesHinweis4, rechtlichesHinweis5, userId, edelmetallWarenkorb, edelmetallWarenkorbPos, innenprovision, emProvZusKz, kundenId, bemerkungen);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Orders, null, [{
    key: "initialize",
    value: function initialize(obj, header, bestellerInformationen, rechtlichesHinweis1, rechtlichesHinweis2, rechtlichesHinweis3, rechtlichesHinweis4, rechtlichesHinweis5, userId, edelmetallWarenkorb, edelmetallWarenkorbPos, innenprovision, emProvZusKz, kundenId, bemerkungen) {
      obj['header'] = header;
      obj['bestellerInformationen'] = bestellerInformationen;
      obj['rechtlichesHinweis1'] = rechtlichesHinweis1;
      obj['rechtlichesHinweis2'] = rechtlichesHinweis2;
      obj['rechtlichesHinweis3'] = rechtlichesHinweis3;
      obj['rechtlichesHinweis4'] = rechtlichesHinweis4;
      obj['rechtlichesHinweis5'] = rechtlichesHinweis5;
      obj['userId'] = userId;
      obj['edelmetallWarenkorb'] = edelmetallWarenkorb;
      obj['edelmetallWarenkorbPos'] = edelmetallWarenkorbPos;
      obj['innenprovision'] = innenprovision;
      obj['emProvZusKz'] = emProvZusKz;
      obj['kundenId'] = kundenId;
      obj['bemerkungen'] = bemerkungen;
    }

    /**
     * Constructs a <code>Orders</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Orders} obj Optional instance to populate.
     * @return {module:model/Orders} The populated <code>Orders</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Orders();
        _HeaderRequest.default.constructFromObject(data, obj);
        if (data.hasOwnProperty('header')) {
          obj['header'] = _RequestHeader.default.constructFromObject(data['header']);
        }
        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
        }
        if (data.hasOwnProperty('bestellerInformationen')) {
          obj['bestellerInformationen'] = _Besteller.default.constructFromObject(data['bestellerInformationen']);
        }
        if (data.hasOwnProperty('rechtlichesHinweis1')) {
          obj['rechtlichesHinweis1'] = _ApiClient.default.convertToType(data['rechtlichesHinweis1'], 'Number');
        }
        if (data.hasOwnProperty('rechtlichesHinweis2')) {
          obj['rechtlichesHinweis2'] = _ApiClient.default.convertToType(data['rechtlichesHinweis2'], 'Number');
        }
        if (data.hasOwnProperty('rechtlichesHinweis3')) {
          obj['rechtlichesHinweis3'] = _ApiClient.default.convertToType(data['rechtlichesHinweis3'], 'Number');
        }
        if (data.hasOwnProperty('rechtlichesHinweis4')) {
          obj['rechtlichesHinweis4'] = _ApiClient.default.convertToType(data['rechtlichesHinweis4'], 'Number');
        }
        if (data.hasOwnProperty('rechtlichesHinweis5')) {
          obj['rechtlichesHinweis5'] = _ApiClient.default.convertToType(data['rechtlichesHinweis5'], 'Number');
        }
        if (data.hasOwnProperty('tlsCode')) {
          obj['tlsCode'] = _ApiClient.default.convertToType(data['tlsCode'], 'String');
        }
        if (data.hasOwnProperty('passwort')) {
          obj['passwort'] = _ApiClient.default.convertToType(data['passwort'], 'String');
        }
        if (data.hasOwnProperty('userId')) {
          obj['userId'] = _ApiClient.default.convertToType(data['userId'], 'String');
        }
        if (data.hasOwnProperty('edelmetallWarenkorb')) {
          obj['edelmetallWarenkorb'] = _Warenkorbdetails.default.constructFromObject(data['edelmetallWarenkorb']);
        }
        if (data.hasOwnProperty('edelmetallWarenkorbPos')) {
          obj['edelmetallWarenkorbPos'] = _ApiClient.default.convertToType(data['edelmetallWarenkorbPos'], [_WarenkorbPos.default]);
        }
        if (data.hasOwnProperty('innenprovision')) {
          obj['innenprovision'] = _ApiClient.default.convertToType(data['innenprovision'], 'Number');
        }
        if (data.hasOwnProperty('emProvZusKz')) {
          obj['emProvZusKz'] = _ApiClient.default.convertToType(data['emProvZusKz'], 'String');
        }
        if (data.hasOwnProperty('beraterKz')) {
          obj['beraterKz'] = _ApiClient.default.convertToType(data['beraterKz'], 'String');
        }
        if (data.hasOwnProperty('kundenId')) {
          obj['kundenId'] = _ApiClient.default.convertToType(data['kundenId'], 'Number');
        }
        if (data.hasOwnProperty('bemerkungen')) {
          obj['bemerkungen'] = _ApiClient.default.convertToType(data['bemerkungen'], ['String']);
        }
        if (data.hasOwnProperty('isMaKond')) {
          obj['isMaKond'] = _ApiClient.default.convertToType(data['isMaKond'], 'Boolean');
        }
        if (data.hasOwnProperty('direktversandKz')) {
          obj['direktversandKz'] = _BooleanJN.default.constructFromObject(data['direktversandKz']);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Orders</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Orders</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(Orders.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // validate the optional field `header`
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['header']) {
        // data not null
        _RequestHeader.default.validateJSON(data['header']);
      }
      // validate the optional field `bestellerInformationen`
      if (data['bestellerInformationen']) {
        // data not null
        _Besteller.default.validateJSON(data['bestellerInformationen']);
      }
      // ensure the json data is a string
      if (data['tlsCode'] && !(typeof data['tlsCode'] === 'string' || data['tlsCode'] instanceof String)) {
        throw new Error("Expected the field `tlsCode` to be a primitive type in the JSON string but got " + data['tlsCode']);
      }
      // ensure the json data is a string
      if (data['passwort'] && !(typeof data['passwort'] === 'string' || data['passwort'] instanceof String)) {
        throw new Error("Expected the field `passwort` to be a primitive type in the JSON string but got " + data['passwort']);
      }
      // ensure the json data is a string
      if (data['userId'] && !(typeof data['userId'] === 'string' || data['userId'] instanceof String)) {
        throw new Error("Expected the field `userId` to be a primitive type in the JSON string but got " + data['userId']);
      }
      // validate the optional field `edelmetallWarenkorb`
      if (data['edelmetallWarenkorb']) {
        // data not null
        _Warenkorbdetails.default.validateJSON(data['edelmetallWarenkorb']);
      }
      if (data['edelmetallWarenkorbPos']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['edelmetallWarenkorbPos'])) {
          throw new Error("Expected the field `edelmetallWarenkorbPos` to be an array in the JSON data but got " + data['edelmetallWarenkorbPos']);
        }
        // validate the optional field `edelmetallWarenkorbPos` (array)
        var _iterator2 = _createForOfIteratorHelper(data['edelmetallWarenkorbPos']),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            _WarenkorbPos.default.validateJSON(item);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        ;
      }
      // ensure the json data is a string
      if (data['emProvZusKz'] && !(typeof data['emProvZusKz'] === 'string' || data['emProvZusKz'] instanceof String)) {
        throw new Error("Expected the field `emProvZusKz` to be a primitive type in the JSON string but got " + data['emProvZusKz']);
      }
      // ensure the json data is a string
      if (data['beraterKz'] && !(typeof data['beraterKz'] === 'string' || data['beraterKz'] instanceof String)) {
        throw new Error("Expected the field `beraterKz` to be a primitive type in the JSON string but got " + data['beraterKz']);
      }
      // ensure the json data is an array
      if (!Array.isArray(data['bemerkungen'])) {
        throw new Error("Expected the field `bemerkungen` to be an array in the JSON data but got " + data['bemerkungen']);
      }
      return true;
    }
  }]);
}();
Orders.RequiredProperties = ["header", "bestellerInformationen", "rechtlichesHinweis1", "rechtlichesHinweis2", "rechtlichesHinweis3", "rechtlichesHinweis4", "rechtlichesHinweis5", "userId", "edelmetallWarenkorb", "edelmetallWarenkorbPos", "innenprovision", "emProvZusKz", "kundenId", "bemerkungen"];

/**
 * @member {module:model/RequestHeader} header
 */
Orders.prototype['header'] = undefined;

/**
 * ID der Bestellung
 * @member {Number} id
 */
Orders.prototype['id'] = undefined;

/**
 * @member {module:model/Besteller} bestellerInformationen
 */
Orders.prototype['bestellerInformationen'] = undefined;

/**
 * Rechtlicher Hinweis (1= bestätigt, 0= nicht bestätigt)
 * @member {Number} rechtlichesHinweis1
 */
Orders.prototype['rechtlichesHinweis1'] = undefined;

/**
 * Rechtlicher Hinweis (1= bestätigt, 0= nicht bestätigt)
 * @member {Number} rechtlichesHinweis2
 */
Orders.prototype['rechtlichesHinweis2'] = undefined;

/**
 * Rechtlicher Hinweis (1= bestätigt, 0= nicht bestätigt)
 * @member {Number} rechtlichesHinweis3
 */
Orders.prototype['rechtlichesHinweis3'] = undefined;

/**
 * Rechtlicher Hinweis (1= bestätigt, 0= nicht bestätigt)
 * @member {Number} rechtlichesHinweis4
 */
Orders.prototype['rechtlichesHinweis4'] = undefined;

/**
 * Rechtlicher Hinweis
 * @member {Number} rechtlichesHinweis5
 */
Orders.prototype['rechtlichesHinweis5'] = undefined;

/**
 * Code für Tls Handshake
 * @member {String} tlsCode
 */
Orders.prototype['tlsCode'] = undefined;

/**
 * Passwort des Kunden
 * @member {String} passwort
 */
Orders.prototype['passwort'] = undefined;

/**
 * ID des Mitarbeiters
 * @member {String} userId
 */
Orders.prototype['userId'] = undefined;

/**
 * @member {module:model/Warenkorbdetails} edelmetallWarenkorb
 */
Orders.prototype['edelmetallWarenkorb'] = undefined;

/**
 * alle Einzelpositionen des Warenkorbs
 * @member {Array.<module:model/WarenkorbPos>} edelmetallWarenkorbPos
 */
Orders.prototype['edelmetallWarenkorbPos'] = undefined;

/**
 * Kosten der Provision
 * @member {Number} innenprovision
 */
Orders.prototype['innenprovision'] = undefined;

/**
 * Provisionszusatz \"J\"a oder \"N\"ein
 * @member {module:model/Orders.EmProvZusKzEnum} emProvZusKz
 */
Orders.prototype['emProvZusKz'] = undefined;

/**
 * hat eine Beratung stattgefunden (J= Ja, N= Nein)
 * @member {module:model/Orders.BeraterKzEnum} beraterKz
 */
Orders.prototype['beraterKz'] = undefined;

/**
 * Kunden ID
 * @member {Number} kundenId
 */
Orders.prototype['kundenId'] = undefined;

/**
 * Zusätzliche Bemerkungen je einzelner Warekorb Position
 * @member {Array.<String>} bemerkungen
 */
Orders.prototype['bemerkungen'] = undefined;

/**
 * Wurde mit Mitarbeiter konditionen gerechnet?
 * @member {Boolean} isMaKond
 */
Orders.prototype['isMaKond'] = undefined;

/**
 * @member {module:model/BooleanJN} direktversandKz
 */
Orders.prototype['direktversandKz'] = undefined;

// Implement HeaderRequest interface:
/**
 * @member {module:model/RequestHeader} header
 */
_HeaderRequest.default.prototype['header'] = undefined;

/**
 * Allowed values for the <code>emProvZusKz</code> property.
 * @enum {String}
 * @readonly
 */
Orders['EmProvZusKzEnum'] = {
  /**
   * value: "J"
   * @const
   */
  "J": "J",
  /**
   * value: "N"
   * @const
   */
  "N": "N"
};

/**
 * Allowed values for the <code>beraterKz</code> property.
 * @enum {String}
 * @readonly
 */
Orders['BeraterKzEnum'] = {
  /**
   * value: "J"
   * @const
   */
  "J": "J",
  /**
   * value: "N"
   * @const
   */
  "N": "N"
};
var _default = exports.default = Orders;